<script setup lang="ts">
const data = inject(keys.packetVariantCard)
</script>

<template>
  <VariantDescription
    :variant="data?.primary"
    class="flex flex-col gap-s md:gap-m"
  />
</template>
